import React from 'react';

const Author = () => {
    return (
        <div className="container">
            <div className="my-5">
                <h2>
                    Author Page
                </h2>
            </div>
        </div>
    );
};

export default Author;